import { Input, ChangeDetectorRef } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { PointStoreProductEditService } from '../../services/point-store-product-edit.service';
import { BaremetricsCalendar } from '../../../../../reusables/baremetrics-calendar/baremetrics-calendar.component';
import { AfterContentChecked } from 'cv-ng-metadata/core';

@Component({
  selector: 'cv-point-store-product-setting',
  templateUrl: './point-store-product-setting.component.html',
  styleUrls: ['./point-store-product-setting.component.scss']
})
export class PointStoreProductSettingComponent implements OnInit, AfterContentChecked {


  pspes = null;
  carouselStartStored = null;
  carouselEndStored = null;
  featuredStartStored = null;
  featuredEndStored = null;
  saleStartStored = null;
  saleEndStored = null;
  variationSaleIsValid = false;
  selectAll = null;
  oldValue = null;

  minSalesPorcentage = 1;
  maxSalesPorcentage = 99;

  @Input() next: (args: number) => void;
  @Input() cancel: () => void;

  constructor(
    private pointStoreProductEditService: PointStoreProductEditService,
    private datePipe: DatePipe,
    private changeDetector: ChangeDetectorRef,
  ) {
    this.pspes = this.pointStoreProductEditService.pointStoreProductEditObj;
  }

  ngOnInit(): void {
    //
  }

  ngAfterContentChecked() {
    this.changeDetector.detectChanges();
  }

  isCarouselRequired(): boolean {
    if (this.pspes.modifiedPointStoreProduct != undefined && this.pspes.settingPointStoreProduct != null && this.pspes.settingPointStoreProduct.Carousel) {
      return true;
    }
  }

  isFeaturedRequired(): boolean {
    if (this.pspes.modifiedPointStoreProduct != undefined && this.pspes.settingPointStoreProduct != null && this.pspes.settingPointStoreProduct.FeaturedProduct) {
      return true;
    }
  }

  checkSale() {
    let itemsOnSale = 0;
    if (this.pspes.modifiedPointStoreProduct != undefined && this.pspes.modifiedPointStoreProduct.VariationsData != undefined && this.pspes.settingPointStoreProduct != null) {
      this.variationSaleIsValid = false;
      if (!this.pspes.modifiedPointStoreProduct.HasProductVariations && this.pspes.settingPointStoreProduct.Sale) {
        return true;
      }
      if (this.pspes.modifiedPointStoreProduct.HasProductVariations) {
        this.pspes.settingPointStoreProduct.Sale = false;
        this.pspes.modifiedPointStoreProduct.VariationsData.forEach((variation) => {
          if (variation.VariationOnSale) {
            this.variationSaleIsValid = true;
            this.pspes.settingPointStoreProduct.Sale = true;
            itemsOnSale++;
          }
        });
        this.selectAll = itemsOnSale == this.pspes.modifiedPointStoreProduct.VariationsData.length ? true : false;
        if (this.variationSaleIsValid) {
          return true;
        }
      }
    }
  }

  convertToDate(date): Date {
    return date ? new Date(date) : null;
  }

  setCarouselStart(date: BaremetricsCalendar) {
    this.pspes.modifiedPointStoreProduct.CarouselStart = this.validateDate(date);
    this.pspes.modifiedPointStoreProduct.CarouselStart_ForView = this.validateDateFormatForView(date);
  }
  setCarouselEnd(date: BaremetricsCalendar) {
    this.pspes.modifiedPointStoreProduct.CarouselEnd = this.validateDate(date);
    this.pspes.modifiedPointStoreProduct.CarouselEnd_ForView = this.validateDateFormatForView(date);
  }

  setFeatureStart(date: BaremetricsCalendar) {
    this.pspes.modifiedPointStoreProduct.FeatureStart = this.validateDate(date);
    this.pspes.modifiedPointStoreProduct.FeatureStart_ForView = this.validateDateFormatForView(date);
  }
  setFeatureEnd(date: BaremetricsCalendar) {
    this.pspes.modifiedPointStoreProduct.FeatureEnd = this.validateDate(date);
    this.pspes.modifiedPointStoreProduct.FeatureEnd_ForView = this.validateDateFormatForView(date);
  }
  setSaleStart(date: BaremetricsCalendar) {
    this.pspes.modifiedPointStoreProduct.SaleStart = this.validateDate(date);
    this.pspes.modifiedPointStoreProduct.SaleStart_ForView = this.validateDateFormatForView(date);
  }

  setSaleEnd(date: BaremetricsCalendar) {
    this.pspes.modifiedPointStoreProduct.SaleEnd = this.validateDate(date);
    this.pspes.modifiedPointStoreProduct.SaleEnd_ForView = this.validateDateFormatForView(date);
  }

  validateDateFormatForView(date: BaremetricsCalendar) {
    return !date.current_date ? null : date.current_date.format(CVMomentDateFormat);
  }

  validateDate(date: BaremetricsCalendar) {
    return date.current_date ? date.current_date.toDate() : null;
  }

  checkboxChanged_showInCarousel() {
    if (this.pspes.settingPointStoreProduct.Carousel) {
      if (this.pspes.modifiedPointStoreProduct.CarouselStart_ForView == null || this.pspes.modifiedPointStoreProduct.CarouselStart_ForView.length <= 0) {
        this.pspes.modifiedPointStoreProduct.CarouselStart = this.pspes.modifiedPointStoreProduct.ProductStart ? new Date(this.pspes.modifiedPointStoreProduct.ProductStart) : null;
        this.pspes.modifiedPointStoreProduct.CarouselStart_ForView = this.pspes.modifiedPointStoreProduct.ProductStart_ForView;
      }
    }
    else {
      this.pspes.modifiedPointStoreProduct.CarouselStart = null;
      this.pspes.modifiedPointStoreProduct.CarouselStart_ForView = null;
      this.pspes.modifiedPointStoreProduct.CarouselEnd = null;
      this.pspes.modifiedPointStoreProduct.CarouselEnd_ForView = null;
    }
    this.pspes.modifiedPointStoreProduct.IsCarouselChecked = this.pspes.settingPointStoreProduct.Carousel;
  };

  checkboxChanged_showInFeatured() {
    if (this.pspes.settingPointStoreProduct.FeaturedProduct) {
      if (this.pspes.modifiedPointStoreProduct.FeatureStart_ForView == null || this.pspes.modifiedPointStoreProduct.FeatureStart_ForView.length <= 0) {
        this.pspes.modifiedPointStoreProduct.FeatureStart = this.pspes.modifiedPointStoreProduct.ProductStart ? new Date(this.pspes.modifiedPointStoreProduct.ProductStart) : null;
        this.pspes.modifiedPointStoreProduct.FeatureStart_ForView = this.pspes.modifiedPointStoreProduct.ProductStart_ForView;
      }
    }
    else {
      this.pspes.modifiedPointStoreProduct.FeatureStart = null;
      this.pspes.modifiedPointStoreProduct.FeatureStart_ForView = null;
      this.pspes.modifiedPointStoreProduct.FeatureEnd = null;
      this.pspes.modifiedPointStoreProduct.FeatureEnd_ForView = null;
    }
    this.pspes.modifiedPointStoreProduct.IsFeaturedChecked = this.pspes.settingPointStoreProduct.FeaturedProduct;
  };

  checkboxChanged_OnSale() {
    if (this.pspes.settingPointStoreProduct.Sale) {
      if (this.pspes.modifiedPointStoreProduct.SaleStart_ForView == null || this.pspes.modifiedPointStoreProduct.SaleStart_ForView.length <= 0) {
        this.pspes.modifiedPointStoreProduct.SaleStart = this.pspes.modifiedPointStoreProduct.ProductStart ? new Date(this.pspes.modifiedPointStoreProduct.ProductStart) : null;
        this.pspes.modifiedPointStoreProduct.SaleStart_ForView = this.pspes.modifiedPointStoreProduct.ProductStart_ForView;
      }
    }
    else {
      this.pspes.modifiedPointStoreProduct.SaleStart = null;
      this.pspes.modifiedPointStoreProduct.SaleStart_ForView = null;
      this.pspes.modifiedPointStoreProduct.SaleEnd = null;
      this.pspes.modifiedPointStoreProduct.SaleEnd_ForView = null;
    }

    this.pspes.modifiedPointStoreProduct.IsOnSaleChecked = this.pspes.settingPointStoreProduct.Sale;

    if (!this.inputFilter(this.pspes.modifiedPointStoreProduct.Sale)) {
      this.pspes.modifiedPointStoreProduct.Sale = this.pspes.modifiedPointStoreProduct.Sale?.replace(/\D/g, "") ?? null;
    }
  };

  checkboxChanged_VariationOnSale() {
    this.pspes.settingPointStoreProduct.Sale = false;
    this.pspes.modifiedPointStoreProduct.VariationsData.forEach((v) => {
      if (v.VariationOnSale)
        this.pspes.settingPointStoreProduct.Sale = true;
    });
    if (this.pspes.settingPointStoreProduct.Sale) {
      if (this.pspes.modifiedPointStoreProduct.SaleStart_ForView == null || this.pspes.modifiedPointStoreProduct.SaleStart_ForView.length <= 0) {
        this.pspes.modifiedPointStoreProduct.SaleStart = this.pspes.modifiedPointStoreProduct.ProductStart ? new Date(this.pspes.modifiedPointStoreProduct.ProductStart) : null;
        this.pspes.modifiedPointStoreProduct.SaleStart_ForView = this.pspes.modifiedPointStoreProduct.ProductStart_ForView;
      }
    }
    else {
      this.pspes.modifiedPointStoreProduct.SaleStart = null;
      this.pspes.modifiedPointStoreProduct.SaleStart_ForView = null;
      this.pspes.modifiedPointStoreProduct.SaleEnd = null;
      this.pspes.modifiedPointStoreProduct.SaleEnd_ForView = null;
    }
    this.pspes.modifiedPointStoreProduct.IsOnSaleChecked = this.pspes.settingPointStoreProduct.Sale;
  }

  checkAll() {
    this.pspes.modifiedPointStoreProduct.VariationsData.forEach(variation => {
      variation.VariationOnSale = this.selectAll;
    });
    this.checkboxChanged_VariationOnSale();
  }


  getPreviewImage() {
    return '../App_Themes/clearview-default/images/gamification/marketplace/layout-options/' + (this.pspes.settingPointStoreProduct && this.pspes.settingPointStoreProduct.Carousel ? 'Y' : 'N') + (this.pspes.settingPointStoreProduct && this.pspes.settingPointStoreProduct.FeaturedProduct ? 'Y' : 'N') + (this.pspes.settingPointStoreProduct && this.pspes.settingPointStoreProduct.Sale ? 'Y' : 'N') + 'T.png';
  }

  getOldValue = function (e) {
    if (e.keyCode == 8 || e.keyCode == 46) return;
    this.oldValue = this.pspes.modifiedPointStoreProduct.Sale != null ? this.pspes.modifiedPointStoreProduct.Sale.toString() : "";
  }

  checkIntFieldValidation = function (e) {
    if (e.keyCode == 8 || e.keyCode == 46) return;
    let validInput = this.inputFilter(e.key);

    if (this.oldValue < 0)
      validInput = false;
    if (this.oldValue != null) {
      if (!this.inputFilter(this.oldValue)) {
        this.oldValue = this.oldValue.replace(/\D/g, "");
      }
    }
    if (!validInput && this.pspes.modifiedPointStoreProduct.Sale != null) {
      this.pspes.modifiedPointStoreProduct.Sale = this.oldValue;
    }
  }

  inputFilter(value) {
    return /^\d*$/.test(value);
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    let inputEl = document.getElementById('input-sale-percentage') as HTMLInputElement;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    } else if (inputEl && inputEl.value.length == 0 && charCode == 48) {
      return false;
    }
    else if (inputEl && inputEl.value.length == 2) {
      if (charCode == 48) {
        return false;
      }
    }
    return true;
  }

  maxLengthCheck(input): void {
    if (input) {
      if (input.target.value.length > input.target.maxLength) {
        input.target.value = input.target.value.slice(0, input.target.maxLength);
        this.pspes.modifiedPointStoreProduct.Sale = input.target.value;
      }
    } else {
      let inputEl = document.getElementById('input-sale-percentage') as HTMLInputElement;
      if (inputEl) {
        if (inputEl.value.length > inputEl.maxLength) {
          inputEl.value = inputEl.value.slice(0, inputEl.maxLength);
          this.pspes.modifiedPointStoreProduct.Sale = inputEl.value;
        }
      }
    }
  }

  validateZero(): void {
    let inputEl = document.getElementById('input-sale-percentage') as HTMLInputElement;
    if (inputEl) {
      if (inputEl.value == '0' || inputEl.value == '00') {
        inputEl.value = '';
        this.pspes.modifiedPointStoreProduct.Sale = inputEl.value;
      }
    }
  }
}
